import Icon from '@mui/icons-material/Search';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function SearchIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
